export enum RegisterUserType {
    Individual = "individual",
    CompanyOrTrust = "companyOrTrust"
}
